/**
 * Route names need to be unique. Therefore we utilize a const object to ensure no collisions
 * When adding a new route the name should be added here first
 * and then referenced in the corresponding `router.ts` file and sidebar item list.
 * Names should be human-readable so they can be used as labek for sidebar item list.
 */
export const RouteNames = {
  LOGIN_CALLBACK: 'LoginCallback',
  APP: 'App',
  HOME: 'Home',
  PROJECT_HOME: 'Projects',
  PROJECTS: 'ProjectsList',
  PROJECT_SUBPAGES: 'ProjectSubpages',
  DEBUG: 'Debug',
  TRACES: 'Traces',
  TRACE: 'Trace',
  OTEL_TRACE: 'oTel-trace',
  PLAYGROUND: 'Playground',
  COMPLETE: 'Complete',
  COLLECTIONS: 'Collections',
  SEARCH: 'Search',
  FINETUNE_HOME: 'Fine-tuning',
  FINETUNE: 'Fine-Tune',
  CHAT: 'Chat',
  DATASET_HOME: 'Datasets',
  DATASETS: 'DatasetsList',
  DATASET: 'DatasetDetail',
  BENCHMARK_HOME: 'Benchmarks',
  BENCHMARKS: 'BenchmarksList',
  BENCHMARK: 'BenchmarkDetail',
  LINEAGES: 'Lineages',
  LINEAGE: 'Lineage',
  NOTFOUND: 'NotFound',
  UNAUTHORIZED: 'Unauthorized',
  APPLICATIONS_HOME: 'Applications',
  RAG_HOME: 'RAG',
  RAG_LIST: 'RAGList',
  RAG_FILES_LIST: 'RagsFilesList',
} as const;

export type RouteNames = (typeof RouteNames)[keyof typeof RouteNames];
